/**
 * Layouts.
 * @module constants/Workflows
 */

import getWorkflowMapping from '@arpav/constants/Workflows';

export default getWorkflowMapping;
